import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

interface RoleRemovedBottomSheetProps {
  modalState: UseModalState;
  qualificationName: string;
}

export function RoleRemovedBottomSheet(props: RoleRemovedBottomSheetProps) {
  const { modalState, qualificationName } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={() => {
              modalState.closeModal();
            }}
          >
            Got it!
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="info"
        title="Role Removed"
        description={`We won't show you any more ${qualificationName} shifts.`}
      />
    </BottomSheet>
  );
}
